import { gql } from '~/techstyle-shared/react-graphql';

export const PROMO_DETAILS_FIELDS_FRAGMENT = gql`
  fragment PromoDetailsFields on PromoDetails {
    promoTypeId
    promoPrice
    promoLabel
    promoCode
    displayOnPdp
  }
`;

export const PRICING_DETAILS_FIELDS_FRAGMENT = gql`
  ${PROMO_DETAILS_FIELDS_FRAGMENT}

  fragment PricingDetailsFields on CustomerProductPrice {
    masterProductId
    dateExpected
    vip
    final
    sales
    retail
    outlet
    retailStoreOutlet
    bogoDetails {
      ...PromoDetailsFields
    }
    discountDetails {
      ...PromoDetailsFields
    }
    markdownPercentOff
    basePrice
    pricingDatasource {
      version
      sourceUrl
    }
  }
`;
